const calculateDaysProgress = (
  startDate: string,
  endDate: string,
  now = Date.now()
) => {
  const startTime = new Date(startDate).getTime();
  const endTime = new Date(endDate).getTime();
  const duration = endTime - startTime;

  if (
    !Number.isFinite(startTime) ||
    !Number.isFinite(endTime) ||
    duration <= 0
  ) {
    return 0;
  }

  const progress = Math.round(((now - startTime) / duration) * 100);

  return Math.min(100, Math.max(0, progress));
};

export default calculateDaysProgress;